export function pushToDataLayer(payload) {
  if (typeof window === 'undefined') return

  if (!window.dataLayer) {
    window.dataLayer = []
  }

  window.dataLayer.push(payload)
}
